<template>
  <Modal :open.sync="open" size="small">
    <div class="dwp-space-y-4">
      <div>
        <div
          class="dwp-text-3xl dwp-text-primary dwp-leading-none dwp-mb-6"
        >Your subscription has expired.</div>
        <div
          class="dwp-font-bold dwp-text-gray-700 dwp-mb-6"
        >Your DocketWP beta subscription has ended, but it's easy to get connected again.</div>
        <span class="dwp-flex dwp-justify-between">
          <span class="dwp-inline-flex rounded-md">
            <a
              href="https://dashboard.docketwp.com"
              target="_blank"
              class="dwp-px-3 dwp-py-2 dwp-text-sm dwp-bg-transparent hover:dwp-bg-transparent dwp-text-gray-600 dwp-border hover:dwp-opacity-75 dwp-border-gray-500 dwp-inline-flex dwp-items-center dwp-border-transparent dwp-leading-4 dwp-font-medium dwp-rounded focus:dwp-outline-none dwp-transition dwp-ease-in-out dwp-duration-150"
            >Renew your subscription</a>
          </span>

          <span class="dwp-inline-flex rounded-md">
            <VButton type="plain" size="tiny" @click.native.prevent="signOut">Sign Out</VButton>
          </span>
        </span>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ui/Modal.vue";
import Logo from "@/components/illustrations/Logo.vue";
import VButton from "@/components/ui/VButton.vue";
import { sync, call } from "vuex-pathify";

export default {
  components: {
    Modal,
    VButton,
    Logo,
  },
  computed: {
    open: sync("ui/open"),
  },
  methods: {
    ...call("user", ["signOut"]),
  },
};
</script>